const FrontendConfig = { 'env': "prod", 'rp_id': "sharepass.com", 'api_endpoint': "https://api.sharepass.com/v1", 'site_url': "https://app.sharepass.com/", 'reCaptchaKey': "6LdWnageAAAAAHrmpd8M6B0cmgfOFuFGemTGUozQ" };
export default FrontendConfig;
